module.exports = "<br><br>\n\n<div style=\"font-size:1.0em;\" id='calendar'></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/trafalgar-event-total-view/trafalgar-event-total-view.component.html
// module id = ./src/app/components/trafalgar-event-total-view/trafalgar-event-total-view.component.html
// module chunks = main